<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <!--<div>idTest1: {{idTest1}}-||||-idTest2: {{idTest2}}</div>-->
        <infoDetail-01 title="详情" :detailInfo="detailInfo" label="INFORMARION" count="20"/>
      </div>
      <div class="content-col col-per-30">
        <infoList title="相关内容" label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock3" :infoPage="infoPage3" v-on:queryPage="hyzx_Req" titleLength="18" count="8"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList01 from '../block/InfoPageList01'
import InfoList from '../block/InfoList'
import TitleInfoBlock01 from '../block/TitleInfoBlock01'
import InfoDetail01 from '../block/InfoDetail01'
import PreviousNextNav from '../utils/PreviousNextNav'

export default {
  name: 'Detail01',
  components: {
    'infoDetail-01': InfoDetail01,
    'infoList': InfoList,
    'previous-next':PreviousNextNav,
  },
  props: {
    idTest1: {
      type: Number,
      default: 0
    },
    idTest2:{
      type:Number,
      default:0
    },
  },
  data() {
    return {
      msg: '',
      infoBlock3:TitleInfoBlock01,
      infoPage3:{},
      detailInfo:{info:{title:'',author:'',create_time:'',view:''},attachment:[]},
    }
  },
  methods:{
    detail_Req(detailId){
      let that=this;
      let params={id:detailId};
      that.$dataApi.articleDetail(params).then(res =>{
          that.msg=res.msg;
          that.detailInfo=res.data;
          //console.log('结束请求Vue-axios：'+JSON.stringify(that.detailInfo))
        });
    },
    //行业资讯
    hyzx_Req(params){
          let that=this;
          let result={page:params};
          console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
          that.$dataApi.articleList(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage3=result;
          //console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
  },
  created:function(){
    let that=this;
    let detailId=that.$route.params.id;
    //console.log("详情页面接收属性：idTest1="+that.idTest1+"--idTest2="+that.idTest2);
    //console.log("详情页面接收参数：params="+JSON.stringify(that.$route.params));
    //console.log("详情页面接收查询：params="+JSON.stringify(that.$route.query));
    that.detail_Req(detailId);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Detail01.vue